import { useTranslation } from 'react-i18next';
import { ActivityTemplate } from '../../models';
import { Link } from 'react-router-dom';

export function ActivityTemplateItem({
  template,
}: {
  template: ActivityTemplate;
}) {
  const [t] = useTranslation(['chatroom']);
  return (
    <div className="flex flex-col rounded-xl shadow-card bg-white flex-shrink-0 w-64 overflow-clip min-h-template-card">
      <div className="relative overflow-clip h-52 max-h-52">
        <div className="absolute top-2.5 right-2.5 py-1 px-3 bg-white rounded-xl text-xs font-bold text-group-info">
          {t('activity_templates_duration', '{{count}} 天的活動', {
            count: template.duration,
          })}
        </div>
        <img
          alt={template.name}
          src={template.imageUrl}
          className="object-cover object-center h-full w-full"
        />
      </div>
      <div className="px-4 pt-3 flex flex-col">
        <span className="font-bold mb-1">{template.name}</span>
        <p className="text-sm text-group-info line-clamp-2 max-h-[40px] overflow-ellipsis whitespace-no-wrap">
          {template.description}
        </p>
      </div>

      <Link
        to={`/template/${template.id}`}
        state={{ template }}
        className="font-bold text-sm text-group-primary underline underline-offset-2 mt-auto p-4"
      >
        {t('activity_templates_view', '檢視活動')}
      </Link>
    </div>
  );
}
